module.exports = __webpack_public_path__ + "media/spacetour.6173d509.mp4";